import PropTypes from "prop-types";
import clsx from "classnames";
import { TabList } from "@/ui/TabList";
import { useLocale } from "@/hooks/useLocale";
import { sites_helper } from "@/helpers/sites_helper";
import { DynamicHtml } from "@/ui/DynamicHtml";
import slug from "slug";
import classes from "./styles.module.scss";
import { Button, Col, Row } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import Image from "@/ui/Image";
import { cleanMarkup } from "@/functions/cleanMarkup";

export const SpecialismsPageCountrySection = ({ className }) => {
  const locale = useLocale();
  const countries = sites_helper.fetch();

  return (
    <div className={clsx(className, classes.tabs)}>
      <TabList
        title={{ path: `page.specialisms.country.title` }}
        text={{ path: `page.specialisms.country.text` }}
        variant="secondary"
        items={countries.map((i) => ({
          title: i.name,
          content: (
            <div key={i.id} className={clsx(classes.tabs__content, "px-4 pb-4 px-md-5 pb-md-5")}>
              <Row className="d-flex justify-content-evenly">
                {"specialisms" in i &&
                  i.specialisms.map((s, k) => (
                    <Col key={k} xs={12} className="px-0" lg={Math.ceil(12 / i.specialisms.length)}>
                      <section
                        className={classes.specialism}
                        style={{ backgroundImage: `url(/assets/specialisms/country/${slug(s.title)}.png)` }}
                      >
                        <div className={clsx(classes.specialism__content, "pt-4 pt-md-5")}>
                          <h4 className="text-lg-end" dangerouslySetInnerHTML={{ __html: s.title }} />
                          <div dangerouslySetInnerHTML={{ __html: cleanMarkup(s.text) }} />
                        </div>
                      </section>
                    </Col>
                  ))}
              </Row>
              <Row>
                <Col xs={12} className="d-flex flex-column pt-4 pt-md-5">
                  <DynamicHtml
                    className="flex-grow-1 small"
                    path={`page.specialisms.country.${slug(i.name)}.bottom.text`}
                  />
                  <Button variant="outline-light" className="arrow-secondary ms-auto" href={i.url}>
                    <DynamicText path={`page.specialisms.country.button.${locale}`} />
                  </Button>
                </Col>
              </Row>
            </div>
          ),
        }))}
      />
    </div>
  );
};

SpecialismsPageCountrySection.defaultProps = {
  className: "py-4 py-md-5",
};

SpecialismsPageCountrySection.propTypes = {
  className: PropTypes.string,
};
